import clsx from "clsx";
import Link from "next/link";

import type { FCWithChildren } from "koljobs-types";

import { getPublicConfig } from "@/helpers/getPublicConfig";

const {
  project: { siteName },
} = getPublicConfig();

export const AuthFooter: FCWithChildren<{
  isMobile?: boolean;
}> = ({ isMobile = false }) => {
  const linkClass = isMobile ? "text-primary" : "text-white underline";

  return (
    <div
      className={clsx(
        isMobile ? "text-gray-700" : "text-white",
        "bg-transparent text-center text-sm font-light",
      )}
    >
      繼續下一步，即表示您同意{siteName}的
      <Link href="/termsOfService" passHref className={linkClass}>
        服務條款
      </Link>
      和
      <Link href="/privacyPolicy" passHref className={linkClass}>
        隱私政策
      </Link>
      。
    </div>
  );
};
